import {IconNameType} from '@toolify/server/src/enum/IconNameType'

const adjectives = [
  'Able', 'Active', 'Adept', 'Agile', 'Alert', 'Amused', 'Astute', 'Avid', 'Bright', 'Brilliant',
  'Busy', 'Calm', 'Capable', 'Clever', 'Cool', 'Crafty', 'Creative', 'Deft', 'Dashing', 'Eager',
  'Earnest', 'Easy', 'Elite', 'Expert', 'Fair', 'Fancy', 'Fast', 'Fine', 'Firm', 'Fit',
  'Flashy', 'Fleet', 'Frank', 'Free', 'Fresh', 'Fun', 'Game', 'Gentle', 'Glib', 'Glossy',
  'Good', 'Grand', 'Great', 'Green', 'Handy', 'Happy', 'Hardy', 'Hearty', 'Keen', 'Kind',
  'Lively', 'Lucky', 'Mild', 'Neat', 'Nice', 'Noble', 'Open', 'Proud', 'Pure', 'Quick',
  'Quiet', 'Rare', 'Real', 'Rich', 'Right', 'Robust', 'Royal', 'Safe', 'Sane', 'Sharp',
  'Sleek', 'Slick', 'Slim', 'Smart', 'Smooth', 'Snug', 'Solid', 'Sound', 'Steady', 'Stout',
  'Strong', 'Super', 'Sure', 'Sweet', 'Tall', 'Tidy', 'Tight', 'Tough', 'True', 'Vast',
  'Versed', 'Vital', 'Vivid', 'Warm', 'Wise', 'Worthy', 'Young', 'Zeal', 'Amiable', 'Blithe',
]

const animalInfo = [
  {
    name: 'Cat',
    icon: IconNameType.Cat,
  },
  {
    name: 'Dog',
    icon: IconNameType.Dog,
  },
  {
    name: 'Horse',
    icon: IconNameType.Horse,
  },
  {
    name: 'Hippo',
    icon: IconNameType.Hippo,
  },
  {
    name: 'Otter',
    icon: IconNameType.Otter,
  },
  {
    name: 'Dragon',
    icon: IconNameType.Dragon,
  },
  {
    name: 'Bird',
    icon: IconNameType.KiwiBird,
  },
  {
    name: 'Worm',
    icon: IconNameType.Worm,
  },
  {
    name: 'Locust',
    icon: IconNameType.Locust,
  },
  {
    name: 'Spider',
    icon: IconNameType.Spider,
  },
  {
    name: 'Bug',
    icon: IconNameType.Bug,
  },
  {
    name: 'Dove',
    icon: IconNameType.Dove,
  },
  {
    name: 'Frog',
    icon: IconNameType.Frog,
  },
  {
    name: 'Crow',
    icon: IconNameType.Crow,
  },
  {
    name: 'Shrimp',
    icon: IconNameType.Shrimp,
  },
  {
    name: 'Mosquito',
    icon: IconNameType.Mosquito,
  },
  {
    name: 'Fish',
    icon: IconNameType.Fish,
  },
]

function getStringHash(str: string): number {
  let hash = 0
  for (let i = 0; i < str.length; i++) {
    hash = ((hash << 5) - hash) + str.charCodeAt(i)
    hash |= 0 
  }
  return Math.abs(hash)
}

export function getGuestDisplayInfo(entityId: string) {
  const hash = getStringHash(entityId)
  
  const adjectiveIndex = hash % adjectives.length
  const animalIndex = (hash >> 4) % animalInfo.length // use different bits for animal
  
  const adjective = adjectives[adjectiveIndex]
  const animal = animalInfo[animalIndex]
  
  return {
    name: `${adjective} ${animal.name}`,
    initials: `${adjective.charAt(0)}${animal.name.charAt(0)}`.toUpperCase(),
    icon: animal.icon,
  }
}
